import { useLayoutEffect } from 'react';
import { View } from 'react-native';
import type { StackScreenProps } from '@react-navigation/stack';
import { useWordsetContext } from '@/contexts/WordSetContext/useWordsetContext';
import { useContinueToSetDetails } from '@/hooks/useContinueToSetDetails';
import { useSetEditorCancel } from '@/hooks/useSetEditorCancel';
import { SecondHeader } from '@/components/SecondHeader';
import { AppHeaderAction } from '@/components/AppHeader/AppHeaderAction';
import { styles as GlobalStyles } from './styles';
import { Icon } from '@/components/Icon';
import { TherapistStackParamList } from '@/navigations/TherapistStack';

type HeaderProps = {
  props: StackScreenProps<TherapistStackParamList, 'WordSet'>;
};

export function Header({ props }: HeaderProps) {
  const {
    apiKeyName,
    setId,
    editData,
    patientId,
    dynamicName,
    selectedWords,
    dataKeyName,
    term,
    termType,
    changeOuterState,
    tags,
    template,
  } = useWordsetContext();

  const noWordsSelected = !selectedWords?.length;

  const { continueToDetails, hasPreviousStep } = useContinueToSetDetails({
    apiKeyName,
    items: selectedWords ?? [],
    dataKeyName,
    dynamicName,
    patientId,
    setId,
    editData,
    template,
  });

  const cancel = useSetEditorCancel(props.route.params.flow, patientId);

  useLayoutEffect(() => {
    props.navigation.setOptions({
      headerLeft: hasPreviousStep
        ? () => (
            <AppHeaderAction
              primary
              onPress={() => props.navigation.goBack()}
              icon={<Icon name="chevronLeft" scale={1.2} />}
              text="Zurück"
            />
          )
        : undefined,
      headerRight: () => (
        <View style={{ gap: 30, flexDirection: 'row' }}>
          <AppHeaderAction
            primary
            onPress={cancel}
            icon={<Icon name="close" scale={1.2} />}
            text="Abbrechen"
          />
          <AppHeaderAction
            primary
            testID="set-items-next-button"
            disabled={noWordsSelected}
            onPress={continueToDetails}
            icon={<Icon name="chevronRight" />}
            text="Weiter"
          />
        </View>
      ),
    });
  }, [noWordsSelected, continueToDetails, hasPreviousStep, cancel]);

  return (
    <View style={GlobalStyles.header}>
      <SecondHeader
        term={term}
        termType={termType}
        changeOuterState={changeOuterState}
        tags={tags}
        type="word"
      />
    </View>
  );
}
